import { ElementRef, useEffect, useRef, useState } from 'react';

import Lottie from 'lottie-react';
import Box from '@mui/material/Box';

import loader from '../../assets/grey-loader.json';
import { getCheckoutUrl } from '../../utils/get-checkout-url';
import { InternalMessageEventsName } from '../../constants/enums';

import './styles.scss';

export function APMDynamicPage() {
  const linkRef = useRef<ElementRef<'a'>>(null);
  const [redirectURL, setRedirectURL] = useState('');

  useEffect(() => {
    const eventHandler = (massageEvent: MessageEvent) => {
      const { params, event } = massageEvent.data;
      const checkoutDomain = getCheckoutUrl();
      if (massageEvent.origin !== checkoutDomain) return;

      if (event === InternalMessageEventsName.APM_REDIRECT) {
        setRedirectURL(params);
      }
      if (event === InternalMessageEventsName.APM_REDIRECT_CLOSE) {
        window.close();
      }
    };

    window.addEventListener('message', eventHandler);

    return () => {
      window.removeEventListener('message', eventHandler);
    };
  }, []);

  useEffect(() => {
    if (redirectURL) {
      linkRef.current?.click();
    }
  }, [redirectURL]);

  return (
    <Box className="wrapper">
      <Lottie
        animationData={loader}
        style={{
          height: '80px',
        }}
        loop={true}
      />
      <a ref={linkRef} href={redirectURL} target="_self" />
    </Box>
  );
}
